import React, { useState } from 'react';
import { Card, CardContent, CircularProgress, Divider, Grid } from '@mui/material';
import { withToast } from '../Shared/Toast';
import ContactInfo from './ContactInfo';
import UserInfo from './UserInfo';
import RelatedAccounts from './RelatedAccounts';

const AccountManagement = ({ account, getAccounts, successToast, errorToast }) => {
    const [loading, setLoading] = useState<boolean>(false)

    const reload = () => {
        setLoading(true)
        getAccounts()
        setLoading(false)
    }

    return (loading ? <div className='loading-container'><CircularProgress className='center-spinner' color="primary" aria-label="Loading" /></div> :
        <Grid container>
            <Grid container xs={12}>
                <Card style={{ width: "100%" }}>
                    <CardContent style={{display: "flex", flexDirection: "column"}}>
                        <UserInfo errorToast={errorToast}  successToast={successToast} />
                        <Divider style={{ marginTop: "10px", marginBottom: "10px" }} />
                        <ContactInfo account={account} update={reload} errorToast={errorToast} successToast={successToast} />
                    </CardContent>
                </Card>
                <Card style={{ width: "100%", marginTop: "20px" }}>
                    <CardContent>
                        <RelatedAccounts account={account} success={successToast} fail={errorToast} reload={reload} />
                    </CardContent>
                </Card>
            </Grid>
        </Grid>);
}
export default withToast(AccountManagement);